const CircledCheckSVG: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11.2264" cy="10.9365" r="10.4383" fill="#231F20" stroke="#D5E709"/>
    <path d="M15.602 6.56104L10.862 15.3117L6.12207 12.0302" stroke="#D5E709" strokeWidth="3"/>
  </svg>

);

export default CircledCheckSVG;
